import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, EventEmitter
} from '@angular/core';

import { FilterApplier, FilterTypes } from '@shared/flight-itinerary/entities/filters';
import { CheckboxFilterVm } from '@shared/filters/entities/fetch-filters.response';
import { AirFilterVm } from '@shared/magic-filter-bar/entities/filter-types';
import { FloatingFilterState } from '@design-system/components/organisms/floating-filter/entities/floating-filter.types';

@Component({
  selector: 'app-air-filter-bar-airlines',
  templateUrl: './air-filter-bar-airlines.component.html',
  styleUrls: ['./air-filter-bar-airlines.component.sass'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AirFilterBarAirlinesContainer {

  @Input() filters: AirFilterVm[];
  @Input() pickedCheckboxes = [];

  @Output() airlineFilterEvent: EventEmitter<{ filter: FilterApplier[] }> = new EventEmitter<{ filter: FilterApplier[] }>();

  constructor() { }

  get airlines(): CheckboxFilterVm[] {
    return [].concat(...this.filters.find(filter => filter.type === FilterTypes.Airlines)?.value as CheckboxFilterVm[]);
  }

  get hasFilterAirline(): boolean {
    return this.numberFilterAirline > 1;
  }

  private get numberFilterAirline(): number {
    return this.airlines?.length;
  }

  public getFloatingFilterState(isActive: boolean): FloatingFilterState {
    return isActive ? FloatingFilterState.Active : FloatingFilterState.Default;
  }

  public trackById(index: number, item: CheckboxFilterVm): string {
    return `${item.AirlineName}-${index}`;
  }

  public activeAirline(airline: CheckboxFilterVm): boolean {
    return this.pickedCheckboxes.includes(airline.Text);
  }

  public selectAirline(selectedAirline: CheckboxFilterVm): void {
    const filters = this.airlines
      .filter(value => value.Text === selectedAirline.Text || (value.Text !== selectedAirline.Text && this.activeAirline(value)))
      .map(value => ({
        type: FilterTypes.Airlines,
        value: value.Text,
        removable: this.activeAirline(value)
      }));
    this.airlineFilterEvent.emit({ filter: filters });
  }

}
